import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { tenantsApi } from 'src/features/tenants/api';

export function useVerifyTenantAlias() {
  const [tenantAlias, setTenantAlias] = useState('');

  const { data: isValid, isLoading } = useQuery({
    queryKey: [`verifyTenantAlias-${tenantAlias}`],
    queryFn: async () => {
      const { exists } = await tenantsApi.verifyTenantAlias(tenantAlias);
      const isValid = !exists;
      return isValid;
    },
    refetchOnWindowFocus: false,
    enabled: !!tenantAlias,
  });

  const handleChangeTenantAlias = (alias: string) => {
    setTenantAlias(alias);
  };

  return {
    isValid,
    isLoading,
    handleChangeTenantAlias,
  };
}
